import { useEffect, useState } from 'react'
import { isMobile } from 'react-device-detect'
import styled from 'styled-components'
import { ProfileRootType } from '../../@types/auth'
import { IssuableAllCouponType } from '../../@types/coupon'
import { OrderItem } from '../../@types/order'
import { getProfile } from '../../api/auth'
import { getIssuableAllCoupon } from '../../api/coupons'
import { getOrderList } from '../../api/orderHistory'
import '../../css/myshopping.css'
import '../../css/Order.css'
import { Button } from '../Button'
import { useCommonContext } from '../provider/CommonProvider'
import { PageTitle } from '../title/PageTitle'
import MyShoppingSideBar from './MyShoppingSideBar'
import {
  DeliveryCompleted,
  DeliveryIng,
  OrderCancelComplete,
  OrderComplete,
  PurChaseConfirmation,
} from './OrderHistoryItem'

export default function OrderList() {
  const [items, setItems] = useState<OrderItem[]>([])
  const [submit, setSubmit] = useState<boolean>(false)
  const [userData, setUserData] = useState<ProfileRootType>()
  const [mypayCount, setMypayCount] = useState<number>(0)
  const [mypayCoupon, setMypayCoupon] = useState<IssuableAllCouponType[]>([])
  const { setIsLottie, hasAccessToken } = useCommonContext()

  useEffect(() => {
    if (hasAccessToken) {
      window.addEventListener('onFocus', () => {
        getOrderList()
          .then((res) => {
            setItems(res.data.items)
            setIsLottie(false)
          })
          .catch((err) => console.log(err))
      })
      getOrderList()
        .then((res) => {
          setItems(res.data.items)
          setIsLottie(false)
        })
        .catch((err) => console.log(err))
    }
  }, [submit, location.pathname, hasAccessToken])

  useEffect(() => {
    if (hasAccessToken) {
      window.addEventListener('onFocus', () => {
        getProfile().then((res) => {
          setUserData(res.data)
        })
        getIssuableAllCoupon().then((res) => {
          const foundCoupon = res.data.find((el: any) => el.couponName === '어바웃피싱 페이 감사 쿠폰')
          if (foundCoupon) {
            setMypayCoupon(foundCoupon)
          }
        })
      })
      getProfile().then((res) => {
        setUserData(res.data)
      })
      getIssuableAllCoupon().then((res) => {
        const foundCoupon = res.data.find((el: any) => el.couponName === '어바웃피싱 페이 감사 쿠폰')
        if (foundCoupon) {
          setMypayCoupon(foundCoupon)
        }
      })
    }
  }, [location.pathname, hasAccessToken])

  useEffect(() => {
    if (items.length !== 0) {
      const mypayCount = items.filter((el: any) => el.pgType === 'MY_PAY').length
      setMypayCount(mypayCount)
    }
  }, [items])

  // 주문내역이 없을 때 박스 높이 조절
  useEffect(() => {
    const contentsWrap = document.querySelector('.contents_wrap')
    if (!contentsWrap) return

    if (items.length === 0) {
      contentsWrap.classList.add('full')
    } else {
      contentsWrap.classList.remove('full')
    }
  }, [items])

  return (
    <>
      <div className='main_wrap'>
        <div className={isMobile ? 'contents_wrap' : 'contents_wrap sidemenu_wrap'}>
          <MyShoppingSideBar />
          <div className='myshopping_wrap'>
            <PageTitle>주문 내역</PageTitle>
            <div className='order_list'>
              {items.length === 0 ? (
                <NoContentWrap>
                  <NoContentCotentWrap2>
                    <img src='/images/empty_logo.png' alt='' />
                    <NoList>구매내역이 없습니다.</NoList>
                  </NoContentCotentWrap2>
                </NoContentWrap>
              ) : (
                items?.map((el: any) => {
                  const array: any = []
                  el.orderOptions?.map((element: any) => {
                    array.push(element.orderStatusType)
                  })

                  if (array.includes('PAY_DONE')) {
                    return <OrderComplete el={el} type={array} key={el.orderNo}></OrderComplete>
                  }
                  if (array.includes('PRODUCT_PREPARE')) {
                    return <OrderComplete el={el} type={array} key={el.orderNo}></OrderComplete>
                  }
                  if (array.includes('DELIVERY_PREPARE')) {
                    return <OrderComplete el={el} type={array} key={el.orderNo}></OrderComplete>
                  }
                  if (array.includes('DELIVERY_ING')) {
                    return <DeliveryIng el={el} key={el.orderNo}></DeliveryIng>
                  }

                  if (array.includes('DELIVERY_DONE')) {
                    return (
                      <DeliveryCompleted
                        setSubmit={setSubmit}
                        el={el}
                        key={el.orderNo}
                        userData={userData}
                        mypayCount={mypayCount}
                        mypayCoupon={mypayCoupon}
                      ></DeliveryCompleted>
                    )
                  }
                  if (array.includes('BUY_CONFIRM')) {
                    return <PurChaseConfirmation el={el} key={el.orderNo}></PurChaseConfirmation>
                  }
                  if (array.includes('RETURN_DONE')) {
                    return <DeliveryCompleted el={el} key={el.orderNo}></DeliveryCompleted>
                  } else {
                    return <OrderCancelComplete el={el} key={el.orderNo}></OrderCancelComplete>
                  }
                })
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export const NoContentWrap = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;

  @media screen and (min-width: 768px) {
    display: flex;
    padding: 0;
    height: 100%;
    justify-content: center;
    align-items: center;
  }
`

export const NoContentContentWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const NoContentTitle = styled.p`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  @media screen and (min-width: 768px) {
    font-size: 20px;
    font-weight: 500;
    line-height: 32px;
  }
`

export const NoContentBtn = styled(Button)`
  display: inline-block;
  font-size: 15px;
  font-weight: 600;
  padding: 12px 35px;
  color: var(--colWhite);
  background: var(--colBlack);
  border-radius: 76px;
  line-height: 20px;
  margin-top: 20px;
  @media screen and (min-width: 768px) {
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    padding: 14px 40px;
    margin-top: 32px;
    cursor: pointer;
  }
`
export const NoContentCotentWrap2 = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 120px 0 160px 0;
  & img {
    width: 85px;
    height: 85px;
  }
  @media screen and (min-width: 768px) {
    & img {
      width: 108px;
      height: 108px;
    }
  }
`

export const NoContentContent = styled.p`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: var(--colGray5);
  text-align: center;
  margin-bottom: 20px;
  @media screen and (min-width: 768px) {
    font-size: 20px;
    font-weight: 500;
    line-height: 32px;
  }
`
export const NoList = styled(NoContentContent)`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  @media screen and (min-width: 768px) {
    font-size: 20px;
    font-weight: 500;
    line-height: 32px;
    margin-top: 0;
  }
`
